<template>
  <nav
    aria-label="Footer"
    class="footer-menu flex flex-wrap justify-between text-center"
    role="navigation"
  >
    <StoryblokComponent
      v-for="item in footerNavigation"
      :key="item._uid"
      :blok="item"
      class="md-3 sm-6 xsl-12 xs-12"
    />
  </nav>
</template>

<script setup lang="ts">
const { navigationMenu } = useConfigStore()
const footerNavigation = computed(() => navigationMenu?.footer)
</script>

<style lang="less">
nav.footer-menu {
  @media @tablet {
    .text-left();
  }

  ul {
    .list-reset();
    .font-body();
    .font-sm();

    @media @tablet {
      padding-right: @gutter;
    }

    &:not(:last-child) {
      margin-bottom: @gutter;
      padding-bottom: @gutter;
      border-bottom: @1px solid @color-border;

      @media @tablet {
        border: none;
      }
      @media @desktop {
        margin: 0;
        padding-bottom: 0;
      }
    }
    &:nth-last-child(2) {
      @media @tablet {
        margin: 0 !important;
        padding: 0 !important;
      }
    }

    li {
      .h4 {
        .uppercase();
        .font-xs();
        .font-body();
        .font-medium();
        .space(0.0125);
      }

      &:not(:last-child) {
        .block();

        margin: 0 0 @gutter-xxs;

        @media @desktop {
          margin: 0 0 @gutter-sm;
        }
      }

      a {
        span,
        .icon {
          pointer-events: none;
        }

        .icon {
          .font-sm();
          margin: 0 @6px 0 -@1px;
        }
      }
    }
  }
}
</style>
